import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import HelpIcon from '@mui/icons-material/QuestionMark';
import { LucketItem } from './lucket/LucketItem.cmp';
import { LucketItemExpanded } from './lucket/LucketItemExpanded.cmp';
import IconClose from './lucket/IconClose';
import { countDoneWeekBucketsForBucket } from './slice/lucket-model/countBuckets';

/**
 * Renders the expanded view of a single bucket with its children
 */
export const ExpandedBucketView = ({
    bucket,
    childLuckets,
    buckets,
    currentDate,
    showDescription,
    onToggleDescription,
    onClose,
    onAddChild
}) => {
    return (
        <div style={{ position: "relative" }}>
            <div className="exitBucket">
                <IconClose edit={onClose} />
            </div>
            <div className="infoExpandedBucket">
                <HelpIcon
                    style={{ width: "30px", height: "30px", cursor: "pointer" }}
                    onClick={onToggleDescription}
                />
            </div>

            <div style={{ display: "flex", flexDirection: "row" }}>
                <div className="lucketItemContainer1" style={{ alignItems: "center" }}>
                    <LucketItemExpanded
                        countWeekDonePoints={countDoneWeekBucketsForBucket(
                            buckets,
                            currentDate,
                            bucket
                        )}
                        showDescription={showDescription}
                        childLuckets={childLuckets}
                        planView
                        lucket={bucket}
                        isExpanded
                    />
                </div>
            </div>

            <div className="lucketitemchildrenexpanded">
                {childLuckets.map((child, index) => (
                    <LucketItem
                        key={"lucketitemchildexpanded" + index}
                        countWeekDonePoints={countDoneWeekBucketsForBucket(
                            buckets,
                            currentDate,
                            child
                        )}
                        planView
                        childLucket
                        lucket={child}
                        isExpandedChild
                    />
                ))}
            </div>

            <div>
                <AddIcon
                    style={{ width: '50px', height: '50px', margin: 'auto', cursor: 'pointer' }}
                    onClick={onAddChild}
                />
            </div>
        </div>
    );
};
